import React from "react";
import { Icon } from "../../../../../../../components";

type StatusProps = {
  status: boolean;
};

const Status: React.FC<StatusProps> = ({ status }) => {
  if (status) {
    return <Icon className="x-large-font success-color" name="checked" />;
  }

  return <Icon className="x-large-font" name="error" />;
};

export default Status;
